<template>
  <v-autocomplete
    v-model="value"
    v-on="inputListeners"
    :items="items"
    item-text="descricao_full"
    item-value="id"
    :label="`Adicionar segmento do fornecedor ${descricao_fornecedor}`"
    multiple
    hide-selected
    append-icon="mdi-plus-circle-outline"
    return-object
  >
    <template #selection>

    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/api/api";
import {logout} from "@/helpers";

export default {
  name: "SysSegmentoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true,
    },
    fornecedores: {
      type: Array,
      default: () => [],
    },
    unidade_medida: String,
    descricao_fornecedor: {
      type: String,
      required: true
    },
  },
  data: () => ({
    items: [],
    timer_buscar_items: null
  }),
  computed: {
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            vm.value = values;
          }
        }
      )
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue)
      }
    }
  },
  watch: {
    unidade_medida() {
      this.getItems();
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems () {
      const params = {
        fornecedores: this.fornecedores,
        unidade_medida: this.unidade_medida,
      };

      api.get('/drp/segmentos', { params })
        .then((response) => {
          this.items = response.data.segmentos.map(item => ({
            ...item,
            percentual_ajustado: 0,
          }));
        })
        .catch(logout)
    }
  }
}
</script>
